module.exports = __webpack_public_path__ + "media/images/new-ui-images/calendar-arrow-412f9b3217b9638406185932d20ff864.svg";